import clsx from 'clsx'

export default function ProgressIndicator({ steps, currentIndex = 0, className = '' }) {
  const arrowClip = 'polygon(0 0, calc(100% - 18px) 0, 100% 50%, calc(100% - 18px) 100%, 0 100%)'
  const rectClip = 'polygon(0 0, 100% 0, 100% 100%, 0 100%)'

  return (
    <div className={clsx('flex items-center gap-2 overflow-x-auto', className)}>
      {steps.map((step, index) => {
        const status = index < currentIndex ? 'done' : index === currentIndex ? 'active' : 'idle'
        const isLast = index === steps.length - 1
        const clip = isLast ? rectClip : arrowClip
        const borderTone =
          status === 'active'
            ? 'bg-primary/20'
            : status === 'done'
              ? 'bg-border-hover'
              : 'bg-border'
        const fillTone =
          status === 'active'
            ? 'bg-[linear-gradient(135deg,rgba(91, 92, 244,0.08),rgba(91, 92, 244,0.02))]'
            : status === 'done'
              ? 'bg-surface'
              : 'bg-bg'
        const textTone = status === 'active' ? 'text-primary' : 'text-foreground-muted'

        return (
          <div key={step} className="relative min-w-[170px] h-16">
            <div className={clsx('absolute inset-0', borderTone)} style={{ clipPath: clip }} />
            <div className={clsx('absolute inset-[1px]', fillTone)} style={{ clipPath: clip }} />
            <div className="relative h-full px-4 py-3">
              <div className="flex items-center justify-between">
                <span className={clsx('text-xs font-mono uppercase tracking-widest', textTone)}>
                  Etape {index + 1}
                </span>
                <span className={clsx('text-xs font-mono', status === 'done' ? 'text-primary' : 'text-foreground-muted')}>
                  {status === 'done' ? 'OK' : status === 'active' ? 'EN COURS' : 'A FAIRE'}
                </span>
              </div>
              <p className={clsx('mt-2 text-sm font-semibold', status === 'active' ? 'text-foreground' : 'text-foreground-secondary')}>
                {step}
              </p>
            </div>
          </div>
        )
      })}
    </div>
  )
}
